<!--
 * @Description: 类1
 * @Author: Fore-Zhang
 * @Date: 2021-01-12 01:14:40
 * @LastEditTime: 2021-01-16 18:17:56
-->
<template>
  <div id="class2" :style="class2Style">
    <div id="Scroller">
      <TopMarquee/>
      <div  id="ArticleCotainer">
        <div class="Article"
             v-for="(a,key) in allArticles" @click="viewArticle(a+1,3,$route.params.class)" :key="key">
          <div class="ArticleImg">
            <img :src="require('../assets/3/'+(a+1)+'/cover.jpg')">
          </div>
          <div class="ArticleTitle">
            {{article(a).shortbrief}}
          </div>
        </div>
      </div>
      <div id="BottomLogoContainer">
        <img src="../assets/list_bottom_logo.png">
      </div>
    </div>
  </div>
</template>

<script>
import articlesStore_3 from "../store/articlesStore_3"
import pageStackStore from "../store/pageStackStore"
import TopMarquee from "./Marquee";
import store from "../store";

export default {
  name: "class2",
  components:{
    TopMarquee
  },
  data(){
    return {
      allArticles:[
      ],
      scrollerClass2:0
    }
  },
  mounted:function () {
    this.getArticles();
    var scrollerConfig = {
      '//Description' : 'Default scroller with no configuration',
      touchSpeed:1
    };
    window.scrollerClass2 = new Scroller('#class2', scrollerConfig);
  },
  methods:{
    article(id){
      return articlesStore_3.state.articles[id];
    },
    getArticles:function () {
      let list=articlesStore_3.state['class'+this.$route.params.class].list
      this.allArticles=list
    },
    viewArticle:function(id,issue,thisclass){
      pageStackStore.commit('pushPageStack', this.$route.path)
      this.$router.replace({ name: 'Article',
        params: { id,issue,class:thisclass}})
    },
  },
  computed:{
    class2Style(){
      return {
        height:(store.state.WindowSize.WindowHeightRem-1.11)+'rem'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidhth{
  width: @fullWidth;
}

#class2{
  .fullWidhth();

  height: 100%;

  #Scroller{
    .fullWidhth();

    background: white;

    #ArticleCotainer{
      .fullWidhth();

      .Article{
        background: #ffffff;
        overflow: hidden;

        width:10.35rem;
        height:5.46rem;
        margin-left: .45rem;
        margin-top:.45rem;
        border-radius:.45rem;
        box-shadow: 0px 0px .15rem .01rem #cccccc;

        .ArticleImg{
          width:10.35rem;

          overflow: hidden;
          height: 3.67rem;

          img{
            width: 100%
          }
        }

        .ArticleTitle{
          color: grey;
          display:flex;
          align-items:center;
          padding-left: .75rem;
          padding-right: .75rem;
          //padding-right: 2.50rem;
          width:10.35rem;
          height:1.79rem;
          font-size:.32rem;
          line-height:.42rem;
        }
      }
    }

    #BottomLogoContainer{
      .fullWidhth();

      height: 2.15rem;
      margin-bottom: 2rem;
      text-align: center;
      display: flex;
      justify-content: center;
      img{
        align-self: center;
        width: 3.23rem;
        height: .55rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/class1.vue